<script lang="ts">
  import { richTextPartnerPanelFormatter } from '$lib/helpers/richTextPartnerPanelHelper';
  export let color: string | undefined = 'text-gray-600';

  export let partnerPanelDescription: any;
  export let image: any;
</script>

<section>
  <div class="p-8 flex bg-gray-50 rounded-xxl">
    <img
      class="max-w-[105px] max-h-[105px] md:max-w-[140px] md:max-h-[140px]"
      src="{image.url}?w=400&fm=webp"
      alt={image?.description || image.title}
    />
    <div class="pl-8 flex flex-col justify-center">
      <div>
        {@html richTextPartnerPanelFormatter(partnerPanelDescription, color)}
      </div>
    </div>
  </div>
</section>
